import styled from '@emotion/styled';
import { ButtonProps, DefaultButtonCss } from '@components/atoms/Inputs/Button/Primary';

const SecondaryButton = styled.button`
  ${DefaultButtonCss};
  background: unset;
  width: 326px;
  height: 48px;
  border-width: 1px;
  border-style: solid;
  border-radius: 48px;
  font-size: 18px;
  border-color: #00bf00;
  color: #00bf00;
  outline: none;
  :hover {
    background: #effdda;
  }
  :active {
    background: #00bf00;
    color: #ffffff;
  }
  :disabled {
    cursor: not-allowed;
    border-color: rgba(255, 255, 255, 0.5);
    color: #ccc;
    &:hover,
    :active {
      background: #d5d5d5;
    }
  }
  ${(props: ButtonProps) => props.styles};
`;

export default SecondaryButton;
